import { create } from "zustand";

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
type GlobalSearchStore = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  openGlobalSearch: () => void;
};

// Shared open state for the ⌘K command palette so the sidebar search trigger
// and the global keyboard shortcut both drive the same dialog.
export const globalSearchStore = create<GlobalSearchStore>((set) => ({
  isOpen: false,
  setIsOpen(isOpen) {
    set({ isOpen });
  },
  openGlobalSearch() {
    set({ isOpen: true });
  },
}));
